import fetch from '@/utils/fetch'

export function groupList (params) {
  return fetch({
    url: '/group/list',
    method: 'get',
    params
  })
}

export function orderPage (data) {
  return fetch({
    url: '/manufactureOrder/page',
    method: 'post',
    data
  })
}

export function fqcSize (data) {
  return fetch({
    url: '/fqcSize/fqcSize',
    method: 'post',
    data
  })
}

export function fqcNgTypeList (data) {
  return fetch({
    url: '/fqcNgType/list',
    method: 'post',
    data
  })
}

export function orderDetail (id) {
  return fetch({
    url: '/order/' + id,
    method: 'get'
  })
}

export function getFqcInfo (data) {
  return fetch({
    url: '/fqc/getFqcInfo',
    method: 'post',
    data
  })
}

export function dayFqcQtyInfo (data) {
  return fetch({
    url: '/fqcSize/dayFqcQtyInfo',
    method: 'post',
    data
  })
}
